import { graphql } from '~publish/graphql'

/**
 * What a reply changes on a conversation row: its status, its last activity
 * and its preview. Reply payloads select only these, so the row the inbox
 * holds keeps everything else, such as its channel and participants, which
 * the API's mock replies do not match.
 *
 * The cache replaces `preview` as one object, so it is selected with every
 * field `ConversationCard_Conversation` reads from it; a field missing here
 * would leave the card without it.
 */
export const ConversationAfterReply_Conversation = graphql(/* GraphQL */ `
  fragment ConversationAfterReply_Conversation on Conversation @_unmask {
    __typename
    id
    status
    lastActivityAt
    preview {
      itemId
      isOwnMessage
      contentType
      text
      publishedAt
      author {
        name
        username
      }
      send {
        state
      }
    }
  }
`)
